import { useApp } from "@/context/AppContext";
import { logoSrc } from "@/lib/themes";
import { cn } from "@/lib/utils";

export const Logo = ({ className, mark = false, light = false, theme, testid = "brand-logo" }) => {
  const { theme: current } = useApp();
  return (
    <img
      src={logoSrc(theme || current, mark, light)}
      alt="Root Equity Partners"
      data-testid={testid}
      draggable={false}
      className={cn("block h-auto max-w-full object-contain select-none", className)}
    />
  );
};

export const BrandLockup = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-lockup">
    <Logo mark className={compact ? "w-10" : "w-12"} testid="brand-mark" />
    <div className="leading-tight">
      <div className="whitespace-nowrap font-display text-[17px] font-bold">Root Equity Partners</div>
      <div className="sidebar-muted whitespace-nowrap text-[10px] uppercase tracking-[0.16em]" data-testid="brand-tagline">
        Come Grow With Us
      </div>
    </div>
  </div>
);
